import React from 'react'
import { ResponsiveContainer, LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip } from 'recharts'

const SensorChart = ({ data, keyName, name, unit }) => {
    return (
        <ResponsiveContainer width="100%" height={300}>
            <LineChart data={data} margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>

                <Line
                    type="monotone"
                    dataKey={keyName}
                    stroke={keyName === 'temp' ? "#f44b42" : "#5963e2"}
                    dot={false}
                    strokeWidth={2}
                    name={name}
                />
                }


                <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />

                <XAxis
                    dataKey="formatted_date"
                    minTickGap={20}
                    reversed={true}
                />

                <YAxis
                    domain={[
                        dataMin => Math.ceil(dataMin) - 2,
                        dataMax => Math.ceil(dataMax) + 2,
                    ]}
                    unit={unit}
                />

                <Tooltip />

            </LineChart>
        </ResponsiveContainer>
    )
}

export default SensorChart


// WEBPACK FOOTER //
// ./src/Shared/SensorChart.js